// Angular Files
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

// Teller Online Files

// Teller Online Library Files
import { TellerOnlineSiteMetadataService } from 'teller-online-libraries/core';

@Injectable({
    providedIn: 'root'
})
export class PortalFeatureGuardService {
    constructor(private router: Router, private siteMetadataService: TellerOnlineSiteMetadataService) { }

    // Routes gated by the AuthenticatedUsers feature
    private _authFeatureRoutes = ['user', 'users', 'users/'];

    // Routes gated by the ScheduledPayments feature
    private _scheduledPaymentRoutes = [
        'scheduled-payments',
        'scheduled-payments/:guid'
    ];

    // Routes gated by the LinkedAccounts feature
    // Matched against a route's own path, character for character — a page left out of this
    // list stays reachable with the feature switched off.
    // Terminology is listed because a linked account is the only term a tenant can rename so far.
    private _linkedAccountRoutes = ['account-links', 'terminology'];

    canActivate(route: ActivatedRouteSnapshot): boolean {
        return this._checkFeatures(route);
    }

    canActivateChild(route: ActivatedRouteSnapshot): boolean {
        return this._checkFeatures(route);
    }

    private _checkFeatures(route: ActivatedRouteSnapshot): boolean {
        const { path } = route.routeConfig;

        if (!this.siteMetadataService.authenticationEnabled
            && this._authFeatureRoutes.includes(path)) {
            this.router.navigate(['/']);
            return false;
        }

        if (!this.siteMetadataService.scheduledPaymentsEnabled
            && this._scheduledPaymentRoutes.includes(path)) {
            this.router.navigate(['/']);
            return false;
        }

        if (!this.siteMetadataService.linkedAccountsEnabled
            && this._linkedAccountRoutes.includes(path)) {
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
